import { Meta, theme } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import PermitParkingSpace from 'screens/permit/PermitParkingSpace';
import { UnifiedPermit } from 'types/generatedSchemaTypes';
import { formatPermitValid } from 'utils/permitUtils';
import TicketRow from '../permitRows/TicketRow';
import { RowContainer } from '../styles';

const AccessGroupLtpPermit = ({
  permit,
  onPress,
}: {
  permit: UnifiedPermit;
  onPress?: () => void;
}) => {
  const { t } = useTranslation();
  if (
    !permit.permitType ||
    (permit.permitType !== 'ACCESS_TO_MEMBER_GROUP_LTP' &&
      permit.permitType !== 'DIGITAL_PERMIT')
  ) {
    return null;
  }

  const { id, freetextParkingSpaceNo } = permit;

  const { validFrom, validTo } = permit.validity || {};

  const parkingSpaces = permit.resolvedParkingSpaces;
  const spotMap = permit.spotMap;

  return (
    <>
      {(parkingSpaces || freetextParkingSpaceNo) && (
        <TicketRow
          title={t('longTermParking.parkingSpace')}
          testID={`permit-${id}-parking-space`}>
          <RowContainer>
            <PermitParkingSpace
              parkingSpaces={parkingSpaces ?? []}
              spotMap={spotMap}
              meta={true}
              freetextParkingSpaceNo={freetextParkingSpaceNo}
            />
          </RowContainer>
        </TicketRow>
      )}
      <TicketRow
        title={t('permit.access.validFrom')}
        testID={`permit-${id}-valid-from`}>
        <RowContainer>
          {validFrom && (
            <Meta testID={`permit-${permit.id}-valid-from-date`}>
              {formatPermitValid(
                validFrom,
                permit.permitType === 'DIGITAL_PERMIT'
              )}
            </Meta>
          )}
        </RowContainer>
      </TicketRow>
      {validTo && (
        <TicketRow
          title={t('permit.access.validTo')}
          testID={`permit-${id}-valid-to`}>
          <RowContainer>
            <Meta testID={`permit-${permit.id}-valid-to-date`}>
              {formatPermitValid(
                validTo,
                permit.permitType === 'DIGITAL_PERMIT'
              )}
            </Meta>
          </RowContainer>
        </TicketRow>
      )}
      <TicketRow
        onPress={onPress}
        titleColor={theme.colors.black}
        title={t('services.viewDetails')}
        divider={false}>
        <Icon
          name="Chevron_Right"
          size="s"
          testID={`permit-${id}-view-details`}
        />
      </TicketRow>
    </>
  );
};

export default AccessGroupLtpPermit;
